const globalScope = typeof window !== 'undefined' ? window : self;

/**
 * Colors
 * ANSI 颜色代码包括：
    30: Black（黑色）
    31: Red（红色）
    32: Green（绿色）
    33: Yellow（黄色）
    34: Blue（蓝色）
    35: Purple（紫色）
    36: Cyan（青色）
    37: White（白色）

    30: 黑色：\u001b[30m
    31: 红色：\u001b[31m
    32: 绿色：\u001b[32m
    33: 黄色：\u001b[33m
    34: 蓝色：\u001b[34m
    35: 紫色：\u001b[35m
    36: 青色：\u001b[36m
    37: 白色：\u001b[37m
      
  每个颜色代码都可以通过后面的 ;1 来加粗显示，例如 33;1 表示加粗的黄色。

  还有背景色的代码，通常以 4x 开头，例如：
    40: BlackBackground（黑色背景）
    41: RedBackground（红色背景）
    42: GreenBackground（绿色背景）
    43: YellowBackground（黄色背景）
    44: BlueBackground（蓝色背景）
    45: PurpleBackground（紫色背景）
    46: CyanBackground（青色背景）
    47: WhiteBackground（白色背景）

    40:黑色背景，加粗，白色文字：\u001b[40;1;37m
    41:红色背景，加粗，白色文字：\u001b[41;1;37m
    42:绿色背景，加粗，白色文字：\u001b[42;1;37m
    43:黄色背景，加粗，白色文字：\u001b[43;1;37m
    44:蓝色背景，加粗，白色文字：\u001b[44;1;37m
    45:紫色背景，加粗，白色文字：\u001b[45;1;37m
    46:青色背景，加粗，白色文字：\u001b[46;1;37m
    47:白色背景，加粗，黑色文字：\u001b[47;1;30m

  \u001b[：这部分是开始 ANSI 转义序列的标志。
  32：表示设置文本颜色为绿色。
  ;：用于分隔不同的属性。
  1：表示启用加粗文本效果。
  m：表示 ANSI 转义序列的结束标志。
    
  例子：'\u001b[40;1;37m' 黑色背景，加粗，白色文字
 */

// Scopes

// 颜色
const scopeColor = {
  'Default' : '\u001b[0m', // (默认颜色)
  'Black' : '\u001b[30m',  //（黑色）
  'Red' : '\u001b[31m',    //（红色）
  'Green' : '\u001b[32m',  //（绿色）
  'Yellow' : '\u001b[33m', //（黄色）
  'Blue' : '\u001b[34m',   //（蓝色）
  'Purple' : '\u001b[35m', //（紫色）
  'Cyan' : '\u001b[36m',   //（青色）
  'White' : '\u001b[37m'  //（白色）
}

// 背景
const descColor = {
  'BlackBackground' : '\u001b[40;1;37m', //（黑色背景，加粗，白色文字）
  'RedBackground' : '\u001b[41;1;37m', //（红色背景，加粗，白色文字）
  'GreenBackground' : '\u001b[42;1;37m', //（绿色背景，加粗，白色文字）
  'YellowBackground' : '\u001b[43;1;37m', //（黄色背景，加粗，白色文字）
  'BlueBackground' : '\u001b[44;1;37m', //（蓝色背景，加粗，白色文字）
  'PurpleBackground' : '\u001b[45;1;37m', //（紫色背景，加粗，白色文字）
  'CyanBackground' : '\u001b[46;1;37m', //（青色背景，加粗，白色文字）
  'WhiteBackground' : '\u001b[47;1;30m' //（白色背景，加粗，黑色文字）
}


export type DebugFunction = (message: string, ...data: any[]) => void;

type ScopeColor = { 
  scope:'Default' | 'Black' | 'Red' | 'Green' | 'Yellow' | 'Blue' | 'Purple' | 'Cyan' | 'White';
  desc:'BlackBackground' | 'RedBackground' | 'GreenBackground' | 'YellowBackground' | 'BlueBackground' | 'PurpleBackground' | 'CyanBackground' | 'WhiteBackground'; 
};

export function createDebug(
  FLAG:boolean | string = false, 
  scope: string = 'Debuger', 
  color: ScopeColor = { scope:'Red', desc:'RedBackground' }, 
  localStorageKey: string = 'VITE_BROWSER_NODE_DEBUG'
): DebugFunction {
  const value = globalScope?.localStorage?.[localStorageKey];
  FLAG = value !== undefined ? value : FLAG;
  return function debug(message: string, ...data: any[]) {
    if (JSON.parse(FLAG.toString()) === true) {
      const cleanMessage = message.replace(/\[.+\]:/, '');
      console.log(`${scopeColor[color.scope]}${scope} - ${descColor[color.desc]}${cleanMessage}`, ...data);
    }
  };
}